var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"rounded-circle shadow select-none",attrs:{"width":_vm.width_img,"height":_vm.height_img,"src":_vm.avatar_arr[_vm.id_avatar]},on:{"click":_vm.AvaClick}})}
var staticRenderFns = []

export { render, staticRenderFns }